import { Icon } from '@toggle/design-system';
import { EventFeedEvent } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useMarkEventRead } from '~/react-query-hooks/events/use-event-feed/useEventFeed';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { getCatalystInsightIconProps } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/utils';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './CompanyCatalystCounterTooltip.styles';

interface CompanyCatalystCounterTooltipProps {
  events: EventFeedEvent[];
  source: PosthogTrackingSource;
  onClose?: () => void;
}

export const CompanyCatalystCounterTooltip = ({
  events,
  source,
  onClose,
}: CompanyCatalystCounterTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();
  const { mutate: markEventRead } = useMarkEventRead();

  return (
    <div onClick={e => e.stopPropagation()}>
      {events.map(event => {
        const entityTag = event.metadata.identifier ?? event.entity;
        const iconProps = getCatalystInsightIconProps({
          isBordered: true,
          isCompanyCatalyst: true,
          isRead: event.read,
        });
        return (
          <S.TooltipWrapper
            key={event.id}
            $isRead={event.read}
            onClick={() => {
              if (entityTag) {
                markEventRead(event.id);
                openDrawer({
                  type: 'company',
                  entityTag,
                  insightId: event.source_id,
                  source,
                });
                onClose?.();
              }
            }}
          >
            <Icon {...iconProps} size={32} />
            <S.RightWrapper>
              <S.TooltipTitleLabel>
                {t('insights:catalyst.titleCompanyCatalyst')}
              </S.TooltipTitleLabel>
              <S.CategoryLabel>
                {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */}
                {event.metadata.sub_category
                  ? t(`catalyst.subcategories.${event.metadata.sub_category}`)
                  : null}
              </S.CategoryLabel>
            </S.RightWrapper>
          </S.TooltipWrapper>
        );
      })}
    </div>
  );
};
